import React, { Fragment } from "react";
import { responseErrors } from "utils";
// Service
import DataTable from "pages/DataTable";
import { API_LOG_MONITORING } from "shared/constants/api-name/common/logMonitoring";
import { PAGINATION, ROW_PER_PAGE } from "shared/constants";
import { DataGridTable } from "components/UI";
export default function TableBar(props) {
  const {
    mode,
    setMode,
    rows,
    setRows,
    columns,
    onSearch,
    searchForm,
    columnsHidden,
    getSearch,
    setMsg: { setMsgAlert, setMsgError },
    rowSelection: { rowSelectionModel, setRowSelectionModel, rowModesModel, setRowModesModel },
    pagination: { pagination, setPagination, pageNumber, setPageNumber },
  } = props;
  const handleChangePagination = async (event, value) => {
    try {
      setPageNumber(value);
      const body = {
        [API_LOG_MONITORING.DATA_OWNER]: searchForm.dataOwner,
        [API_LOG_MONITORING.MODULE_ID]: searchForm.moduleId,
        funtionId: searchForm.functionId,
        [API_LOG_MONITORING.STATUS_ID]: searchForm.statusId,
        // for training
        // [API_LOG_MONITORING.LEVEL_ID]: searchForm.levelId,
        [API_LOG_MONITORING.LEVEL_ID]: searchForm.levelId, //Fix INC342
        [API_LOG_MONITORING.USER_ID]: searchForm.userId,
        [API_LOG_MONITORING.APP_ID]: searchForm.appId,
        [API_LOG_MONITORING.DATE_FORM]: !searchForm?.dateFrom ? "" : searchForm?.dateFrom,
        [API_LOG_MONITORING.DATE_TO]: !searchForm?.dateTo ? "" : searchForm?.dateTo,
        [PAGINATION.PAGE_NUMBER]: value,
        [PAGINATION.ROW_PER_PAGE]: ROW_PER_PAGE,
      };
      const { searchData, data } = await getSearch(body);
      setPagination(searchData?.result?.pagination ?? {});
      setPageNumber(searchData?.result?.pagination?.pageNumber);
      setRows(data);
    } catch (error) {
      const msg = responseErrors(error);
      setMsgError(msg);
      return;
    }
  };

  return (
    <Fragment>
      <DataGridTable
        mode={mode}
        onSearch={onSearch}
        rowSelectionModel={rowSelectionModel}
        setRowSelectionModel={setRowSelectionModel}
        setMode={setMode}
        rows={rows}
        rowModesModel={rowModesModel}
        setRowModesModel={setRowModesModel}
        checkboxSelection={false}
        autoHeight={true}
        // tableHeight={300}
        tableHeight={rows?.length <= 10 ? "auto" : "600px"}
        column={{
          columns,
          columnVisibilityModel: {
            [API_LOG_MONITORING.ROW_NUMBER]: false,
            [API_LOG_MONITORING.MESSAGE_TYPE]: false,
            ...columnsHidden,
          },
        }}
        pagination={{ pagination, pageNumber, handleChangePagination }}
        rowSelection={{ rowModesModel, setRowModesModel, rowSelectionModel, setRowSelectionModel }}
      />
    </Fragment>
  );
}
